:host {
  position: sticky;
  top: 0;
  z-index: 10002;
  display: block;
  width: 100%;
  background-color: #237ad9;

  .container {
    display: none;

    &.open {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 44px;
      padding-right: 15px;
      padding-left: 15px;
    }

    a {
      margin-right: auto;
      margin-bottom: 0;
      margin-left: auto;
      color: white;
    }

    sy-icon {
      --sy-icon-color: white;

      cursor: pointer;
    }
  }
}
